export enum WireActionTypeEnum {
    save,
    submit,
    cancel,
    retract,
    backToDraft,
    publish,
    preview
}
